import { defineStore } from 'pinia'

import jobApi from '@/api/job'

import { useMainStore } from './main'
/* eslint-disable */
const successStatusCode = 1000

export const useJobStore = defineStore('job', {
  state: () => ({
    jobs: [], // will be deleted
    availableFilters: {},
    jobCount: 0,
    jobList: [],
    jobDetail: {},
    resume: {},
    resumeError: {},
    jobDetailError: {},
    application: {},
    related: [],
    paginationToken: ''
  }),
  getters: {
    getApplication () {
      return this.application.responseObject || {}
    }
  },
  actions: {
    getJobs({ data, success, fail } = {}) { // will be deleted
      jobApi.getJobs(data).then(response => {
        this.jobs = response.body.responseObject
        success && success(response)
      }, response => {
        fail && fail(response)
      })
    },
    getAvailableFilters({ success, fail } = {}) {
      jobApi.getAvailableFilters().then(response => {
        this.availableFilters = response.body.responseObject
        success && success(response)
      }, response => {
        fail && fail(response)
      })
    },
    getJobCount({ data, success, fail } = {}) {
      jobApi.getJobCount(data).then(response => {
        this.jobCount = response.body.responseObject
        success && success(response)
      }, response => {
        fail && fail(response)
      })
    },
    searchJob({ data, success, fail } = {}) {
      jobApi.searchJob(data).then(response => {
        if (response.body?.status?.code !== 1000) {
          return fail && fail(response)
        }
        this.jobList = response.body.responseObject
        this.paginationToken = response.body.paginationToken
        success && success(response)
      }, response => {
        fail && fail(response)
      })
    },
    getJobDetail({ data, success, fail } = {}) {
      useMainStore().loaderView(true)
      jobApi.getJobDetail(data).then(response => {
        if (response.body?.status?.code === successStatusCode) {
          this.jobDetail = response.body.responseObject
          success && success(response)
        } else {
          this.jobDetailError = response.body.status
          useMainStore().loaderView(false)
        }
      }, response => {
        this.jobDetail = {}
        fail && fail(response)
        useMainStore().loaderView(false)
      })
    },
    uploadFile({ data, success, fail } = {}) {
      useMainStore().loaderView(true)
      jobApi.uploadFile(data).then(response => {
        this.resume = response.body.responseObject
        useMainStore().loaderView(false)
        success && success(response)
      }, response => {
        fail && fail(response)
      })
    },
    applyJob({ data, success, fail } = {}) {
      jobApi.applyJob(data).then(response => {
        this.application = response.body
        success && success(response)
      }, response => {
        fail && fail(response)
      })
    },
    submitGeneralForm({ data, success, fail } = {}) {
      jobApi.submitGeneralForm(data).then(response => {
        this.application = response.body
        success && success(response)
      }, response => {
        fail && fail(response)
      })
    }
  },
})
